import { ELinkManagementTabs } from '@organisms/Enterprise/LinksManagement/enums';
import LinkManagementTableTabs from '@organisms/Enterprise/LinksManagement/LinkManagementTableTabs/LinkManagementTableTabs';
import EnterpriseLinksManagementTable from '@organisms/Tables/Enterprise/LinksManagementTable/EnterpriseLinksMangementTable';
import { useState } from 'react';

const EnterpriseLinksManagement = () => {
  const [selectedTab, setSelectedTab] = useState<ELinkManagementTabs>(ELinkManagementTabs.All);
  const handleTableTabsChanges = (tab: ELinkManagementTabs) => {
    setSelectedTab(tab);
  };

  return (
    <>
      <LinkManagementTableTabs handleTableTabsChanges={handleTableTabsChanges} />
      <EnterpriseLinksManagementTable selectedTab={selectedTab} />;
    </>
  );
};

export default EnterpriseLinksManagement;
